// PlanCard.js — PLAN KARTI (1 Eki 2026'da App.js'ten taşındı)
//
// 🔑 Serkan (1 Eki 2026, ofis talebi): web açılışı doğrudan admin panel; Dashboard kalktı, işlevleri admin panelde
//    FLT OPS'a taşındı (*"dashboard'u zaten FLT OPS içine taşımış olacağız"*). Kart AYNI kaldı — yalnız yeri değişti.
//
// 🔴 ACTIVE/DEACTIVATE KALKTI (3 Kas 2026, saha: paket uçuş LTAC-LTAT/LTAT-LTAC — Serkan: "web'de artık active
//    deactive olmayacak, sadece available planlar olacak"). Eskiden "+ Activate" planı ŞİRKET GENELİNDE tek aktif
//    yapıyordu ve bunu yapan pilotun ekip arkadaşı AYNI planı kendi cihazında AVAILABLE'da göremiyordu (AAK bulgusu).
//    Artık aktivasyon yalnız iPad'de, yalnız cihazda — web'den kimse kimseyi kilitleyemez. "İşleniyor mu, kim
//    işliyor" bilgisi `PLAN_ACTIVATED` log olayından (flight_logs) gelir — bloklamaz, salt bilgidir.
import React from 'react';
import { utcGun } from '../utcTarih';   // UTC + ay adı sabit (Eylül "Sept" değil "SEP")

export default function PlanCard({ plan, archived, isleyenler, onActivity, onDelete, onReport }) {
  return (
    <div style={{ background: archived ? 'var(--bg2)' : 'var(--bg3)', border:`1px solid var(--border)`, borderRadius:10, overflow:'hidden', marginBottom:8, opacity: archived ? 0.85 : 1 }}>
      <div style={{ padding:'12px 14px', display:'flex', alignItems:'center', gap:12, borderBottom:'1px solid var(--border)' }}>
        <div style={{ flex:1 }}>
          <div style={{ fontSize:16, fontWeight:700, color:'var(--t1)', fontFamily:'monospace', letterSpacing:1 }}>
            {plan.dep} <span style={{ color: archived ? 'var(--t3)' : 'var(--accent)' }}>→</span> {plan.dest}
          </div>
          <div style={{ fontSize:11, color:'var(--t3)', marginTop:2 }}>{plan.date} · STD {plan.std} Z · {plan.ac} / {plan.reg}</div>
        </div>
        <span style={{ fontSize:10, fontWeight:700, padding:'2px 8px', borderRadius:4, letterSpacing:0.5,
          background: archived ? 'rgba(100,100,100,0.15)' : 'var(--green-soft)',
          color: archived ? 'var(--t3)' : 'var(--green)' }}>
          {archived ? 'ARCHIVED' : 'AVAILABLE'}
        </span>
      </div>
      <div style={{ padding:'9px 14px', display:'flex', gap:10, alignItems:'center', flexWrap:'wrap' }}>
        {/* DATE + FLT TIME (31 Tem): ayni rotada iki farkli ucus olabilir —
            planli tarih ve ucus suresi karti tek basina ayirt eder (iOS ile ayni). */}
        <div style={{ fontSize:11, color:'var(--t3)' }}>DATE <b style={{ color:'var(--t2)', marginLeft:3 }}>{plan.date}</b></div>
        <div style={{ fontSize:11, color:'var(--t3)' }}>ETD <b style={{ color:'var(--t2)', marginLeft:3 }}>{plan.std}</b></div>
        <div style={{ fontSize:11, color:'var(--t3)' }}>ETA <b style={{ color:'var(--t2)', marginLeft:3 }}>{plan.eta}</b></div>
        <div style={{ fontSize:11, color:'var(--t3)' }}>FLT TIME <b style={{ color:'var(--t2)', marginLeft:3 }}>{plan.ete}</b></div>
        <div style={{ fontSize:11, color:'var(--t3)' }}>FOB <b style={{ color:'var(--t2)', marginLeft:3 }}>{plan.fob}</b></div>
        {!archived && isleyenler && isleyenler.length > 0 && (
          <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
            {isleyenler.map(kod => (
              <span key={kod} style={{ display:'flex', alignItems:'center', gap:5, background:'rgba(66,209,128,.1)', border:'1px solid rgba(66,209,128,.3)', borderRadius:6, padding:'3px 8px', fontSize:10, fontWeight:700, color:'var(--green)' }}>
                <span style={{ width:6, height:6, borderRadius:3, background:'var(--green)', display:'inline-block' }}/>{kod}
              </span>
            ))}
          </div>
        )}
        {!archived && onDelete && (
          <button onClick={onDelete} style={{ background:'transparent', border:'1px solid var(--red)', borderRadius:6, padding:'4px 10px', fontSize:11, fontWeight:700, color:'var(--red)', cursor:'pointer', fontFamily:'inherit' }}>
            ✕ Delete
          </button>
        )}
        {!archived && onActivity && (
          <button onClick={onActivity} style={{ marginLeft:'auto', background:'transparent', border:'1px solid var(--accent)', borderRadius:6, padding:'5px 13px', fontSize:11, fontWeight:700, color:'var(--accent)', cursor:'pointer', fontFamily:'inherit' }}>
            ⏱ View Activity
          </button>
        )}
        {archived && (
          <div style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:8 }}>
            <span style={{ fontSize:10, color:'var(--t3)', fontWeight:700 }}>🔒 Read Only</span>
            {onReport && <button onClick={onReport} style={{ background:'var(--accent-soft)', border:'1px solid var(--accent)', borderRadius:6, padding:'4px 10px', fontSize:11, fontWeight:700, color:'var(--accent)', cursor:'pointer', fontFamily:'inherit' }}>📄 Report</button>}
          </div>
        )}
        {plan.archived_at && archived && (
          <div style={{ fontSize:10, color:'var(--t3)', width:'100%', marginTop:4 }}>
            Archived: {utcGun(plan.archived_at)}
          </div>
        )}
      </div>
    </div>
  );
}
